module.exports = __webpack_public_path__ + "img/please_andriod.e24518b6.png";